import { action } from 'satcheljs';
import { getCurrentUPN } from '../utils/getUserData';
import { addDatapointConfig } from 'owa-analytics-actions';

import { GraphTokenState } from '../store/schema/GraphToken';

/**
 * Action to be taken for setting the current state of retrieving a Graph token
 */
/* skip-unused-action -- This action logs datapoints, and shouldn't be blindly removed.
 * However, it should be replaced with direct calls to logUsage() or PerformanceDatapoint as appropriate,
 * rather than doing it this hacky way.
 */
export const setGraphTokenState = action(
    'setGraphTokenState',
    (graphTokenState: GraphTokenState) => {
        if (graphTokenState == GraphTokenState.Failed) {
            let userData: string = '';
            try {
                userData = getCurrentUPN() || '';
            } catch (e) {
                // pass
            }
            return addDatapointConfig(
                {
                    name: 'FTGraphTokenFailed',
                    customData: {
                        userData,
                    },
                },
                {
                    graphTokenState,
                }
            );
        } else {
            return {
                graphTokenState,
            };
        }
    }
);
